export default __webpack_public_path__ + "d9ca7b7140c58149df99062c5bc70335.png";